import useEmblaCarouselOriginal from 'embla-carousel-react'

/* reexported with a TS type because original module has default export */
export const useEmblaCarousel =
  useEmblaCarouselOriginal as unknown as typeof useEmblaCarouselOriginal.default
